export function Field({
  label,
  required,
  hint,
  error,
  className = '',
  children,
}) {
  return (
    <div className={`field ${error ? 'has-error' : ''} ${className}`.trim()}>
      {label ? (
        <label className="field-label">
          {label}
          {required ? <span className="req">*</span> : null}
          {hint ? (
            <span className="hint-icon" title={hint}>
              i
            </span>
          ) : null}
        </label>
      ) : null}
      {children}
      {error ? <span className="field-error">{error}</span> : null}
    </div>
  );
}
